import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRequest } from 'app/shared/Domains/request';
import { Configuration } from "config/config";
import { ActivatedRoute, Router } from "@angular/router";
import {
  SelectItem,
  ConfirmationService,
  MessageService,
} from "primeng/api";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { IMember } from 'app/shared/Domains/member';
import { IMemberFreezeDetail } from 'app/shared/Domains/memberFreezeDetail';
import { ISettings } from "app/shared/Domains/settings";
import { IMemberEmergencyContact } from "app/shared/Domains/memberEmergencyContact";
import { Customerstrainer } from "app/shared/Domains/Customerstrainer";
import { ICompany } from "app/shared/Domains/company";
import { IAddress } from "app/shared/Domains/address";
import { IMemberContact } from "app/shared/Domains/memberContact";
import { MemberService } from 'common/services/member.service';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-freeze-request-detail',
  templateUrl: './freeze-request-detail.component.html',
  styleUrls: ['./freeze-request-detail.component.css']
})
export class FreezeRequestDetailComponent implements OnInit {
  member: IMember;
  loading: boolean;
  freezeMemberDetails: any[];
  company: ICompany;
  request: IRequest;
  freezeDetail: IMemberFreezeDetail;
  requestId: string;
  currentUserData:any ;
  @Input() requestor: any = [];
  @Output("reject") reject: EventEmitter<any> = new EventEmitter();

  constructor(
    private LanguageService: LanguageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    private services: MemberService,
    public config: Configuration
  ) {
    // route.params.subscribe((params) => {
    //   this.requestId = params["id"];
    //   if (this.requestId !== undefined) {
    //     this.requestId = params["id"];

    //   }
    // });
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("FreezeRequestDetailComponent", label);
  }
  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUser);
    this.request = new IRequest();
    this.request.name = this.requestor[0].name;
    this.requestor = this.requestor;
    this.member = new IMember();
    this.company = new ICompany();
    this.freezeDetail = new IMemberFreezeDetail();
    this.getCustomer();
  }
  InitObjects() {
    // this.requestor = new IRequest();
    this.member.settings = new ISettings();
  }

  getCustomer() {
    this.services.getCustomerByID(this.requestor[0].memberId).subscribe((result: any) => {
      this.member = result;
    }, (error) => {

    })
  }

  freezeMember() {
    this.confirmationService.confirm({
      message: "Are you sure you want to Freeze member ?",
      accept: () => {
        this.loading = true;
        let startDate: any = new Date(this.requestor[0].freezeRequest.startFreezingDate); //lets say this is our days date. (in real you can get todays date like this --> var d = new Date();//
        let endDate = new Date(this.requestor[0].freezeRequest.endFreezingDate); // this is customers joining date that we can get from database.
        if (startDate.getDate() >= endDate.getDate()) {
          // here we compare days of complete date. e.g 25,15,23 etc.
          let tempDate = +new Date(
            startDate.getFullYear(),
            startDate.getMonth() + 1,
            endDate.getDate()
          );
          let diffTime = tempDate - startDate;
          let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          this.member.freezeDetail.daysLeft = Math.abs(diffDays);
        } else {
          let diffDays: any =
            endDate.getDate() - startDate.getDate();
          this.member.freezeDetail.daysLeft = Math.abs(diffDays); // if joiningdate is greater than todays date, simply subtract.
        }
        this.member.freezeDetail.isFreeze = true;
        this.member.type = 'Freeze';
        this.member.scope = 'Member';
        this.member.initiatedFrom = 'freeze request detail';
        this.member.currentUserData = this.currentUserData;
        forkJoin([
          this.appServiceManager
            .get("customers/approveRequest/" + this.requestor[0].requestId),
          this.appServiceManager
            .put("customers/freeze/" + this.member._id, this.member)
        ])
          .subscribe(
            (res: any) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: "success",
                summary: "Success Message",
                detail: "Approved Freeze Request!!!",
              });
              setTimeout(() => {
                this.router.navigateByUrl(
                  "/requests-management"
                );
              }, 300);
            },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error,
              });
            }
          );
      },
    });
  }


  setMemberData(member: IMember) {
    let date = new Date();
    member.settings = new ISettings();
    if (this.company.globalSetting && this.company.globalSetting.dueDate) {
      member.settings.dueDate = this.company.globalSetting.dueDate;
    } else {
      member.settings.dueDate = new Date();
    }
    this.freezeDetail.daysLeft = 0;
    this.freezeDetail.freezeDate = "";
    this.freezeDetail.isFreeze = false;
    member.freezeDetail = this.freezeDetail;
  }

  getFreezeReport() {
    this.freezeMemberDetails = [];
    this.appServiceManager
      .get("customers/freezeMemberDetails/" + this.requestor[0].tagNumber)
      .subscribe(
        (res: any) => {
          if (res) {
            this.freezeMemberDetails = res;
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "Something Went Wrong",
            });
          }
        },
        (error) => {
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );
  }

  validateMember(res) {
    if (
      this.member.settings === null ||
      this.member.settings === undefined
    ) {
      this.member.settings = new ISettings();
      this.member.settings.dueDate = null;
    } else if (
      this.member.settings.dueDate === null ||
      this.member.settings.dueDate === undefined
    ) {
      this.member.settings = new ISettings();
      this.member.settings.dueDate = null;
    } else if (res.settings.dueDate === "null") {
      this.member.settings.dueDate = null;
    } else {
      var dueDate = JSON.stringify(res.settings.dueDate);
      var DD = JSON.parse(dueDate).split("/");
      if (DD.length === 1) {
        this.member.settings.dueDate = new Date(DD);
      } else {
        var newDDate = DD[1] + "/" + DD[0] + "/" + DD[2];
        if (newDDate) {
          this.member.settings.dueDate = new Date(newDDate);
        }
      }
    }
    if (
      this.member.customerstrainer === undefined ||
      this.member.customerstrainer === null
    ) {
      this.member.customerstrainer = new Customerstrainer();
      this.member.customerstrainer.name = "";
      this.member.customerstrainer.trainerId = "";
      this.member.customerstrainer.totalFees = "";
    }
    if (
      this.member.emergencyContact === null ||
      this.member.emergencyContact === undefined
    ) {
      this.member.emergencyContact = new IMemberEmergencyContact();
    } else if (
      this.member.emergencyContact.medicalDetail === null ||
      this.member.emergencyContact.medicalDetail === undefined
    ) {
      this.member.emergencyContact = new IMemberEmergencyContact();
    }
    if (this.member.contactDetail.address) {
      if (
        this.member.contactDetail.address.street === null &&
        this.member.contactDetail.address.street === ""
      ) {
        this.member.contactDetail.address.street = "";
      }
      if (
        this.member.contactDetail.address.city === null &&
        this.member.contactDetail.address.city === ""
      ) {
        this.member.contactDetail.address.city = "";
      }
      if (
        this.member.contactDetail.address.country === null &&
        this.member.contactDetail.address.country === ""
      ) {
        this.member.contactDetail.address.country = "";
      }
      if (
        this.member.contactDetail.address.state === null &&
        this.member.contactDetail.address.state === ""
      ) {
        this.member.contactDetail.address.state = "";
      }
      if (
        this.member.contactDetail.address.zipCode === null &&
        this.member.contactDetail.address.zipCode === ""
      ) {
        this.member.contactDetail.address.zipCode = "";
      }
      if (
        this.member.contactDetail.address.town === null &&
        this.member.contactDetail.address.town === ""
      ) {
        this.member.contactDetail.address.town = "";
      }
    } else {
      this.member.contactDetail.address = new IAddress();
    }
  }

  rejectRequest() {
    this.reject.emit();
  }

}
